export default __webpack_public_path__ + "static/science-pigment-42fde078fb3f9e72532658a56328fcc4.jpg";